<template>
	<div class='select' :class='{"is-open": isOpened}'>
		<icon icon-name='arrow' />
		<div class='select__active'
			@click='clickHandle'>{{selectedLabel}}</div>
		<div class='select__label'>{{ label }}</div>
		<transition>
			<ul class='select__list' v-if='isOpened' v-click-outside='hideHandle'>
				<li class='select__list-item' @click="selectHandle({value: '', lable: ''})">-- Not selected --</li>
				<li class='select__list-item'
					v-show='model!==item.value'
					:key='index'
					v-for='(item, index) in options'
					@click='selectHandle(item)'>{{ item.label }}</li>
			</ul>
		</transition>
	</div>
</template>

<script>
import icon from '__jsVueUI/icon.vue';
import ClickOutside from 'vue-click-outside';
export default {
	name:  'c-select-2',
	props: {
		options: {
			type:    Array,
			default: () => {
				return [];
			}
		},
		value: {
			type:    [Number, String],
			default: ''
		},
		label: {
			type:   String,
			defaut: ''
		}
	},

	components: {
		icon
	},

	data() {
		return {
			isOpened:       false,
		};
	},

	methods: {
		selectHandle(option) {
			this.model = option.value;
			this.isOpened = false;
		},
		clickHandle() {
			setTimeout(() => {
				this.isOpened = !this.isOpened;
			}, 0);
		},
		hideHandle() {
			if (this.isOpened) {
				this.isOpened = false;
			}
		},
	},
	computed: {
		selectedLabel() {
			let index = this.options.map((option) => {
				return option.value;
			}).indexOf(this.model);
			if (index > -1) {
				return this.options[index].label;
			}
			return '';
		},
		model: {
			get() {
				return this.value;
			},
			set(newVal) {
				this.$emit('input', newVal);
				this.$emit('change', newVal);
				this.$emit('complete', newVal);
			}
		},
	},
	directives: {
		ClickOutside
	},
};
</script>
